<script setup lang="ts">
const props = defineProps(
  {
    blobId: { type: Number, required: true }
  })
const { data: blob } = await useFetch(`/api/blob/${props.blobId}`)
</script>
<template>
<div
      class="d-flex align-center flex-row justify-space-between flex-wrap">
      <p class="description">
        {{ blob?.description }}
      </p>
      <div class="blob_actions">
        <client-only>
          <v-menu
            open-on-hover
            location="left"
          >
            <v-card
              width="400"
              rounded="0"
              class="blobInfo"
              :title="blob?.name"
              subtitle="List of sources and tags assigned to this blob"
            >
              <v-list density="compact">
                <v-list-item
                  v-for="filter in blob?.Filter"
                  :key="filter.id"
                >
                  <v-chip
                    v-for="source in filter.sources"
                    :key="source.id"
                    class="mr-1 mt-1"
                  >
                    {{ source.name }}
                  </v-chip>
                  <v-chip
                    v-for="tag in filter.tags"
                    :key="tag.id"
                    :color="filter.inclusive ? 'red': 'primary'"
                    class="mr-1 mt-1"
                  >
                    {{ tag.name }}
                  </v-chip>
                  <v-icon
                    v-if="filter.negative"
                    color="red"
                  >
                    mdi-minus
                  </v-icon>
                </v-list-item>
              </v-list>
            </v-card>
            <template v-slot:activator="{ props }">
              <v-btn
                v-bind="props"
                color="primary"
                variant="text"
                icon="mdi-information"
                target="_blank"
              />
            </template>
          </v-menu>
          <template v-slot:placeholder>
            <v-btn
              icon="mdi-information"
              variant="text"
              color="primary"
            />
          </template>
        </client-only>
        <!-- <v-tooltip text="Feed" location="top">
            <template v-slot:activator="{ props }">
              <v-btn v-bind="props" target="_blank" :href="`/feed/${blob?.id}`" variant='text' color="primary" icon='mdi-rss' />
            </template>
          </v-tooltip> -->
        <v-tooltip
          text="Share"
          location="top"
        >
          <template v-slot:activator="{ props }">
            <v-btn
              v-bind="props"
              :to="`/share?blob_id=${blobId}`"
              variant="text"
              color="primary"
              icon="mdi-widgets-outline"
            />
          </template>
        </v-tooltip>
      </div>
    </div>
    </template>